module.exports = __webpack_public_path__ + "static/media/keep_silent.54990a50.png";